import { TABS_VALUES } from '@hapana/shared/web/components/shared/modal-alerts/notes-properties/modal-alerts.constants'
import type { AlertSystemType } from '../../config/alertSystem.types'

export const alertModalTabOverrides = {
  payment: TABS_VALUES[0],
  agreements: TABS_VALUES[0],
  forms: TABS_VALUES[0],
  notesProps: TABS_VALUES[1],
  location: TABS_VALUES[0],
  birthday: TABS_VALUES[0],
  packages: TABS_VALUES[0],
  firstSession: TABS_VALUES[0],
  introOffers: TABS_VALUES[0],
  suspended: TABS_VALUES[0],
  daysAbsent: TABS_VALUES[0],
  destinationFee: TABS_VALUES[0],
  customAlert: TABS_VALUES[0],
} satisfies Record<AlertSystemType, string | undefined>
